import classNames from 'classnames';
import styles from './FormfieldGroup.module.scss';
import { ErrorMessage } from 'ui/components';

type State = {
	required?: boolean;
	disabled?: boolean;
	hasError?: boolean;
};

export interface FormfieldGroupProps {
	className?: string;
	id: string;
	name?: string;
	label?: string;
	children: React.ReactNode;
	register?: any;
	errorMessage?: string;
	state?: State;
	ariaLabelledby?: string;
}

const ariaError = (state: State, name: string, id: string) => {
	if (state?.['hasError']) return name + id;
};

export const FormfieldGroup: React.FC<FormfieldGroupProps> = ({
	className,
	id,
	name,
	label,
	register,
	errorMessage,
	state,
	children,
	ariaLabelledby,
}) => {
	const { required, disabled, hasError } = state ?? {};
	return (
		<fieldset
			name={name}
			className={classNames(styles.FormfieldGroup, className, { [styles.hasError]: hasError }, { [styles.isDisabled]: disabled })}
			{...(register && { ...register(name, { required }) })}
			aria-describedby={ariaError(state, name, id)}
			aria-labelledby={ariaLabelledby ? ariaLabelledby : id}
		>
			<legend
				id={id}
				className={classNames(styles.FormLabel, styles.FormfieldGroup_label, {
					[styles.FormfieldGroup_label____labelledByOther]: ariaLabelledby,
				})}
			>
				{label}
				{required && (
					<span className={styles.FormLabel___required} aria-hidden="true">
						*
					</span>
				)}
			</legend>
			{children}
			{hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
		</fieldset>
	);
};
